import { APIService } from '@laxmimanogna/code-quick-components';
import { whichTokenToUse } from '../utils/isManagerCreatedToken';



export const API = new APIService({ accessTokenPreferenceKey: whichTokenToUse() })